import eventbus from 'tiny-emitter/instance';
import { TYPE } from '@/constants';
import { DraggableMixin } from '@/core/mixins/DraggableMixin';
import { RotatableMixin } from '@/core/mixins/RotatableMixin';
import { ResizableMixin } from '@/core/mixins/ResizableMixin';
import { SelectableMixin } from '@/core/mixins/SelectableMixin';

import Model from '../model';
import { loadPredefinedUnit, DEFAULT_PREDEFINED, getScale } from './index';
import Application from '@/core/application';

export class PredefinedShape extends ResizableMixin(RotatableMixin(DraggableMixin(SelectableMixin(Model)))) {
  constructor(params) {
    super(params);
    this.app = Application.instance;
    this.initView();
    this.render();
  }

  get type() {
    return TYPE.PREDEFINED;
  }

  initView() {
    const { position, rotation } = this.attributes;
    const [x, y] = position;
    this.shape = loadPredefinedUnit(this.attributes.unitType, this.canvas);
    this.view = this.canvas.group().addClass('predefined');
    this.view.add(this.shape);
    if (this.attributes.scale === undefined) {
      this.attributes.scale = getScale(this.attributes.unitType);
    }
    this.onResize(this.attributes.scale);
    this.view.transform({ rotation }).transform({ x, y });
  }

  render() {}

  clone(options) {
    const { keepPosition } = options;
    const shapeJson = this.toJSON();
    if (!keepPosition) {
      shapeJson.attributes.position[0] += 50;
      shapeJson.attributes.position[1] += 50;
    }

    shapeJson.uuid = this.getUniqueId();
    return PredefinedShape.fromJSON(shapeJson);
  }

  toJSON() {
    const { uuid, type, sid } = this;
    const { matrix, rotation } = this.view.transform();
    const attributes = Object.assign({}, this.attributes, {
      position: [matrix.e, matrix.f],
      rotation,
    });
    return PredefinedShape.filteredJSON({
      uuid,
      sid,
      type,
      attributes,
    });
  }

  destroy() {
    this.view.remove();
    eventbus.emit('unit:removed', this);
    if (this === this.app.seatmap.stagepin) {
      this.app.seatmap.stagepin = undefined;
    }
  }

  static fromJSON(params) {
    return PredefinedShape.create(params);
  }

  static create(params) {
    const attributes = {
      position: [0, 0],
      rotation: 0,
      scale: 1,
      unitType: DEFAULT_PREDEFINED,
    };
    params.attributes = Object.assign({}, attributes, params.attributes);
    return new PredefinedShape(params);
  }
}
